import { render, staticRenderFns } from "./ItemProdDbItems.vue?vue&type=template&id=48d0b2e0&scoped=true&"
import script from "./ItemProdDbItems.vue?vue&type=script&lang=js&"
export * from "./ItemProdDbItems.vue?vue&type=script&lang=js&"
import style0 from "./ItemProdDbItems.vue?vue&type=style&index=0&id=48d0b2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0b2e0",
  null
  
)

component.options.__file = "ItemProdDbItems.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VDialog,
  VFlex,
  VImg,
  VLayout,
  VPagination,
  VSelect,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
